var map = {
	"./authorize.svg": 2340,
	"./canceled.svg": 2341,
	"./capture.svg": 2342,
	"./card-authentication-line.svg": 2343,
	"./collect-card.svg": 2344,
	"./created.svg": 2345,
	"./failed.svg": 2346,
	"./processing.svg": 2347,
	"./requires-action-line.svg": 2348,
	"./requires-confirmation.svg": 2349,
	"./requires-payment-method.svg": 2350,
	"./succeeded.svg": 2351,
	"./verified.svg": 2352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2339;